// staying backward compatible
import { EXIT_CODES } from '@iobroker/js-controller-common';

export default EXIT_CODES;
